<template>
  <div
    class="filter-selector col-12 col-md-5 col-lg-5 col-xl-3 px-0"
    v-if="filters && filters.length"
  >
    <div
      class="filter-selector__item"
      v-for="filter in filters"
      :key="filter.name"
    >
      <FilterType
        :filter="filter"
        :updateFunction="updateDataOfCharts"
      ></FilterType>
    </div>
  </div>
</template>

<script>
// import FilterType from "@/own/components/dashboard/filters/FilterType";
import FilterTypeConsistent from "@/own/components/dashboard/filters/FilterTypeConsistent";
export default {
  name: "FilterSelector.vue",
  props: ["filters", "updateDataOfCharts"],
  components: { FilterType: FilterTypeConsistent },
};
</script>

<style scoped>
.filter-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
}

.filter-selector__item {
  flex: 1 1 160px;
  min-width: 140px;
}

@media (max-width: 575px) {
  .filter-selector__item {
    flex-basis: 100%;
  }
}

@media (min-width: 992px) {
  .filter-selector {
    flex-wrap: nowrap;
  }
}
</style>
